// extracted by mini-css-extract-plugin
export default {"progressWrapper":"Progress_progressWrapper__KxUCe","progress":"Progress_progress__bo1ur"};